<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'RanksAgeAverage',
};
</script>

<style scoped>

</style>
